// enum of all feature flags
const FeatureFlag = {
  SalaryGuidance: 'salary_guidance',
  CandidateProfileV2: 'release_candidate_profile_v2',
  ReleaseCandidatePDFV2: 'release_candidate_pdf_v2',
}

Object.freeze(FeatureFlag)

export default FeatureFlag
